import { bidIncrements } from './hampton.constants';

export const filterLots = (
  lots: HamptonTypes.Lot[],
  filters: HamptonTypes.Filters,
  personalizedFilters: HamptonTypes.PersonalizedFilters,
) => {
  return lots.filter((lot) => {
    const isTypeMatch = filters.type.includes(0) || filters.type.includes(lot.category);
    const isSearchMatch = String(lot.lotNumber)
      .toLowerCase()
      .includes(filters.search.toLowerCase());
    const isDescriptionMatch =
      lot.lotDescription.toLowerCase().includes(filters.description.toLowerCase()) ||
      lot.lotName.toLowerCase().includes(filters.description.toLowerCase());
    const isNotViewedMatch = !personalizedFilters.notViewed || !lot.isViewed;
    const isWatchingMatch = !personalizedFilters.watching || lot.isWatching;

    return (
      isTypeMatch && isSearchMatch && isDescriptionMatch && isWatchingMatch && isNotViewedMatch
    );
  });
};

export const sortLots = (lots: HamptonTypes.Lot[], sort: HamptonTypes.Sort) => {
  return lots.sort((a, b) => {
    if (sort.field === 'category') {
      if (a[sort.field] === '') {
        return 1;
      }
      return a[sort.field].localeCompare(b[sort.field]) * (sort.order === 'asc' ? 1 : -1);
    }

    let aValue = a[sort.field] ?? 0;
    let bValue = b[sort.field] ?? 0;

    return sort.order === 'asc' ? aValue - bValue : bValue - aValue;
  });
};

export const generateBidIncrementOptions = () => {
  return bidIncrements.reduce((all, current) => {
    const [range, increment] = current;
    const possibleBidsCount = Math.ceil((range[1] + 1 - range[0]) / increment);
    const bids = new Array(possibleBidsCount).fill(0).map((_, i) => range[0] + i * increment);

    return [...all, ...bids];
  }, [] as number[]);
};

export const getFeePercent = (bid: number) => {
  if (bid < 50001) {
    return 0.22;
  }
  if (bid < 250001) {
    return 0.2;
  }
  return 0.18;
};
